import type { IconSvgObject } from './types';

const Tap01Icon: IconSvgObject = [
  ["path", { d: "M16.9986 22V20L18.2202 18.1688C18.7287 17.4067 19 16.5112 19 15.5953C19 14.875 18.8393 14.1508 18.3401 13.6312C17.4889 12.7453 15.7191 11.5 12.4954 11.5V6.50106C12.4954 5.67205 11.8234 5 10.9944 5C10.1654 5 9.49331 5.67205 9.49331 6.50106L9.5 15L7.77579 13.2837C7.09052 12.5989 5.96172 12.6614 5.35632 13.4176C4.85711 14.0412 4.88532 14.9348 5.42287 15.5257L9.49331 20V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 6C7 3.79086 8.79086 2 11 2C13.2091 2 15 3.79086 15 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Tap01Icon;
